import React, { useReducer } from 'react';
import clienteAxios from '../../config/axios';
import Swal from 'sweetalert2';

import proyectoContext from './proyectoContext';
import proyectoReducer from './proyectoReducer';
import { 
    FORMULARIO_PROYECTO,
    FORMULARIO_EDITAR,
    OBTENER_PROYECTOS,
    OBTENER_ULTIMOS_CAMBIOS,
    ULTIMO_CAMIBIO,
    AGREGAR_PROYECTO,
    VALIDACION_FORMULARIO,
    PROYECTO_ACTUAL,
    ELIMINAR_PROYECTO,
    ACTUALIZAR_PROYECTO,
    CAMBIAR_VISTA,
    CAMBIAR_PROYECTO,
    CAMBIAR_ALTURA_CONTENEDOR,
    REINICIAR_PROYECTO_STATE
} from '../../types';

const ProyectoState = props => {

    const initialState = {
        proyectos: [],
        ultimoscambiosproyecto: [],
        formulario: false,
        formularioeditar: false,
        errorformulario: false,
        proyecto: null,
        verdetalles: false,
        proyectoactivo: false,
        alturaactualcontenedor: window.innerHeight - 56,
        mensaje: null
    }

    // Dispatch para ejecutar las acciones
    const [ state, dispatch ] = useReducer(proyectoReducer, initialState);

    // Funcion que obtiene la fecha actual
    const obtenerFechaActual = () => {
        var date = new Date();
        var hour = date.getHours();
        hour = (hour < 10 ? "0" : "") + hour;
        var min  = date.getMinutes();
        min = (min < 10 ? "0" : "") + min;
        var sec  = date.getSeconds();
        sec = (sec < 10 ? "0" : "") + sec;
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = (month < 10 ? "0" : "") + month;
        var day  = date.getDate();
        day = (day < 10 ? "0" : "") + day;
        return day + "/" + month + "/" + year + " - " + hour + ":" + min + ":" + sec;
    }

    // ********************
    // Crear las funciones
    // ********************

    // Muestra el formulario de proyectos
    const mostrarFormulario = () => {
        dispatch({
            type: FORMULARIO_PROYECTO
        })
    }

    // Muetra el formulario con diseño de editar un proyecto
    const mostrarFormularioEditar = () => {
        dispatch({
            type: FORMULARIO_EDITAR
        })
    }

    // Obtener los proyectos
    const obtenerProyectos = async () => {
        try {
            const resultado = await clienteAxios.get('/api/proyectos');

            dispatch({
                type: OBTENER_PROYECTOS,
                payload: resultado.data.proyectos
            })
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    // Obtener los ultimos cambios
    const obtenerUltimosCambios = async proyecto => {
        try {
            const respuesta = await clienteAxios.get('/api/ultimoscambios', {params: { proyecto }});
            
            dispatch({
                type: OBTENER_ULTIMOS_CAMBIOS,
                payload: respuesta.data.ultimosCambios
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    // Funcion que guarda el ultimo cambio
    const guardarUltimoCambio = async (proyecto, lugar, nombre, accion) => {
        const fechaCreacion = obtenerFechaActual();
        const ultimocambio = { lugar, nombre, accion, fechaCreacion, proyecto };

        try {
            const respuesta = await clienteAxios.post('/api/ultimoscambios', ultimocambio);
            
            dispatch({
                type: ULTIMO_CAMIBIO,
                payload: respuesta.data.ultimoCambio
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }
    
    // Agregar nuevo proyecto
    const agregarProyecto = async proyecto => {
        proyecto.fechaCreacion = obtenerFechaActual()

        try {
            const resultado = await clienteAxios.post('/api/proyectos', proyecto);
            
            // Inserta el proyecto en el state
            dispatch({
                type: AGREGAR_PROYECTO,
                payload: resultado.data
            });
            Swal.fire({
                title: '¡Agregado!',
                text: 'El proyecto se agregó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    // Valida el formulario por errores
    const mostrarError = () => {
        dispatch({
            type: VALIDACION_FORMULARIO,
            payload: true
        });

        setTimeout(() => {
            dispatch({
                type: VALIDACION_FORMULARIO,
                payload: false
            });
        }, 5000);
    }

    // Selecciona el proyecto al que el usuario le dio click
    const proyectoActual = proyectoId => {
        dispatch({
            type: PROYECTO_ACTUAL,
            payload: proyectoId
        })
    }

    // Elimina un proyecto
    const eliminarProyecto = async proyectoId => {
        try {
            await clienteAxios.delete(`/api/proyectos/${proyectoId}`);
            dispatch({
                type: ELIMINAR_PROYECTO,
                payload: proyectoId
            });
            Swal.fire({
                title: '¡Eliminado!',
                text: 'El proyecto se eliminó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    // Edita un proyecto
    const actualizarProyecto = async proyecto => {
        try {
            const respuesta = await clienteAxios.put(`/api/proyectos/${proyecto._id}`, proyecto);
            
            dispatch({
                type: ACTUALIZAR_PROYECTO,
                payload: respuesta.data.proyecto
            });
            proyectoActual(proyecto._id);

            Swal.fire({
                title: '¡Editado!',
                text: 'El proyecto se editó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    // Cambiar a vista de detalles del proyecto
    const verDetalles = status => {
        dispatch({
            type: CAMBIAR_VISTA,
            payload: status
        })
    }

    // Cambia si un pryecto está activo o no
    const proyectoActivo = status => {
        dispatch({
            type: CAMBIAR_PROYECTO,
            payload: status
        })
    }

    // Funcion que obtiene la altura del contenedor principal
    const obtenerAlturaContenedor = alturaActual => {
        dispatch({
            type: CAMBIAR_ALTURA_CONTENEDOR,
            payload: alturaActual
        })
    }

    const reiniciarProyectoState = () => {
        dispatch({
            type: REINICIAR_PROYECTO_STATE
        })
    }

    return(
        <proyectoContext.Provider
            value={{
                proyectos: state.proyectos,
                ultimoscambiosproyecto: state.ultimoscambiosproyecto,
                formulario: state.formulario,
                formularioeditar: state.formularioeditar,
                errorformulario: state.errorformulario,
                proyecto: state.proyecto,
                verdetalles: state.verdetalles,
                proyectoactivo: state.proyectoactivo,
                alturaactualcontenedor: state.alturaactualcontenedor,
                mensaje: state.mensaje,
                mostrarFormulario,
                mostrarFormularioEditar,
                obtenerProyectos,
                obtenerUltimosCambios,
                guardarUltimoCambio,
                agregarProyecto,
                mostrarError,
                proyectoActual,
                eliminarProyecto,
                actualizarProyecto,
                verDetalles,
                proyectoActivo,
                obtenerAlturaContenedor,
                reiniciarProyectoState
            }}
        >
            {props.children}
        </proyectoContext.Provider>
    )
}

export default ProyectoState;